<template>
  <section id="content-terms">
    <h2>Price &amp; Terms</h2>

    <div class="info-card">
      <div class="info-item-group list asking">
        <img src="./assets/target.svg" />
        <div class="financials-data">
            <span class="d-block">{{ askingPrice | currency(true) }}</span>
            <label class="d-block">Asking Price</label>
        </div>
      </div>
    </div>

    <v-row>
      <v-col cols="6" class="transition-info">
        <div class="info-grid content-financials">
          <div class="financials">
            <img class="mt-n3" src="./assets/handshake.svg" height="50" />
            <div class="financials-data">
              <span>{{ cashDown }}%</span>
              <label>Cash Down</label>
            </div>
          </div>

          <div class="financials">
            <img src="./assets/briefcase.svg" height="46" />
            <div class="financials-data">
              <span>{{ escrow }}%</span>
              <label>Escrow</label>
            </div>
          </div>

          <div class="financials">
            <img src="./assets/calendar.svg" height="46" />
            <div class="financials-data">
              <span>{{ closeDateString }}</span>
              <label>Anticipated Close Date</label>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="6" class="transition-info">
        <div class="info-grid content-transition">
          <div class="info-item-group">
            <label>Consulting Timeline</label>
            <span>{{ consultingTimeline || 'N/A' }}</span>
          </div>
          <div class="info-item-group">
            <label>Business Development</label>
            <span>{{ businessDevelopment ? 'Yes' : 'No' }}</span>
          </div>
          <div class="info-item-group">
            <label>Post-Transition</label>
            <span>{{ postTransition ? 'Yes' : 'No' }}</span>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" style="padding-bottom: 100px">&nbsp;</v-col>
    </v-row>

  </section>
</template>

<script>
import dateformat from 'dateformat'

export default {
    name: 'DetailsTermsInformation',
    props: {
        askingPrice: {
            type: String,
            default: '0',
        },
        cashDown: {
            type: String,
            default: '0',
        },
        escrow: {
            type: String,
            default: '0',
        },
        closeDate: {
            type: String,
            default: 'N/A',
        },
        consultingTimeline: {
            type: String,
            default: 'N/A',
        },
        businessDevelopment: {
            type: Boolean,
            default: null
        },
        postTransition: {
            type: Boolean,
            default: null
        }
    },

    computed: {
        closeDateString () {
        return this.closeDate && this.closeDate !== 'N/A'
            ? dateformat(this.closeDate, 'mmmm yyyy')
            : this.closeDate
        },
    },
}
</script>

<style scoped>
.info-card {
  border: .2em dashed #97C131 !important;
  grid-template-columns: auto !important;
}

.info-card .info-item-group {
  justify-content: center;
  align-items: center;
}

.info-card img {
  height: 6em !important;
  width: 6em !important;
}

.info-card span {
  font-family: "SansationBold", sans-serif !important;
  font-size: 3.2em !important;
  line-height: 1em !important;
}

.info-card label {
  font-family: "Sansation", sans-serif !important;
  font-size: 1.6em !important;
  line-height: 1.5em !important;
}

.info-card .asking {
  display: flex;
  align-self: center;
}

.info-grid {
  margin-top: 0 !important;
  grid-template-columns: auto !important;
  background-color: #EFEFEF !important;
}

.info-grid .info-item-group {
  padding: 0 0 20px 0 !important;
  border-bottom: none !important;
}

.info-grid .info-item-group label,
.transition-info label {
  font-family: 'Sansation', sans-serif !important;
  font-size: 16px !important;
  line-height: 20px !important;
}

.info-grid .info-item-group span {
  font-family: 'SansationBold', sans-serif !important;
  font-size: 16px !important;
  line-height: 20px !important;
}

.info-grid.content-financials {
  margin: 0;
  flex: 1 0 50%;

  grid-template-rows: 50px 70px 70px;
  grid-row-gap: 10px;
}
.financials {
  display: flex;
  align-items: center;
  text-align: left;
  color: #5F6062;
}
.info-grid .financials .financials-data {
  align-items: center;
  margin-left: 1em;
}

.info-grid .financials img {
  display: inline;
  align-content: center;
}
.info-grid .financials span {
  font-family: 'SansationBold', sans-serif !important;
  font-size: 2em !important;
  line-height: 1.1em !important;
  align-items: center;
  margin: auto .3em;
  display: block;
}
.info-grid .financials label {
  font-family: 'Sansation', sans-serif !important;
  font-size: 1.2em !important;
  line-height: 1em !important;
  align-items: center;
  margin: auto .6em;
  display: block;
}

.info-grid.content-transition {
  margin: 0;
  flex: 1 0 50%;

  grid-template-rows: 50px 70px 70px;
  grid-row-gap: 10px;
}

.info-grid.content-transition .info-item-group {
  margin: 0 !important;
  padding: 0 !important;
  grid-template-columns: 1fr 120px;
  grid-column-gap: 10px;
  align-items: stretch;
}

.info-grid.content-transition .grid-title {
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  align-items: center;

  background-color: #99CC33;
  color: white;
  font-family: "SansationBold", sans-serif;
  font-size: 12pt;
  line-height: 13pt;
}

.content-transition .info-item-group:nth-child(1) * {
  background-color: #99CC3320;
}
.content-transition .info-item-group:nth-child(2) * {
  background-color: #E3E3E3;
}
.content-transition .info-item-group:nth-child(3) * {
  background-color: #99CC33;
}

.content-transition .info-item-group * {
  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/TermsInformation.vue